import React, { useState } from 'react';

/**
 * Impersonation banner.
 *
 * Shown on every page while an admin is "logged in as" another user (set by the
 * Features & Access panel's Impersonate action, which stashes the admin's own
 * tokens under `inikru_impersonation_return`). Returning restores the admin
 * session and goes back to the admin panel.
 */
const RETURN_KEY = 'inikru_impersonation_return';
const WHO_KEY = 'inikru_impersonating';

const readReturn = () => {
  try {
    const raw = localStorage.getItem(RETURN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
};

const ImpersonationBanner = () => {
  const [ret] = useState(readReturn);
  if (!ret) return null;

  const who = (() => {
    try { return localStorage.getItem(WHO_KEY) || 'user'; } catch (_e) { return 'user'; }
  })();

  const goBack = () => {
    try {
      if (ret.authToken) localStorage.setItem('authToken', ret.authToken);
      else localStorage.removeItem('authToken');
      if (ret.access_token) localStorage.setItem('access_token', ret.access_token);
      else localStorage.removeItem('access_token');
    } catch (_e) { /* ignore */ }
    try {
      localStorage.removeItem(RETURN_KEY);
      localStorage.removeItem(WHO_KEY);
    } catch (_e) { /* ignore */ }
    window.location.href = '/inikru-admin';
  };

  return (
    <div
      role="status"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14,
        padding: '8px 14px', background: '#1B1B1B', color: '#fff',
        fontSize: 13.5, fontWeight: 600, boxShadow: '0 2px 10px rgba(0,0,0,.25)',
      }}
    >
      <span>🎭 You are viewing INIKRU as <strong>{who}</strong> (admin impersonation)</span>
      <button
        type="button"
        onClick={goBack}
        style={{
          background: '#B40A0A', color: '#fff', border: 'none', borderRadius: 8,
          padding: '5px 12px', fontWeight: 700, fontSize: 12.5, cursor: 'pointer',
        }}
      >
        ← Return to admin
      </button>
    </div>
  );
};

export default ImpersonationBanner;
